<template>
  <div class="col-6 col-sm p-1">
    <div class="card card-border border-success shadow-lg">
      <div @click="removeToCompare" class="cancel-list shadow">
        <i class="fe fe-x text-white"></i>
      </div>
      <div class="card-body row text-center">
        <div class="col-12 bg-white stikybar-md border border-dark p-1">
          <a :href="casino.link_casino" rel="nofollow sponsored" target="_blank" :title="'Sito casinò ' +  casino.nome">
          <img class="img-fluid border" :src="'https://img.casino2k.com/' + casino.logo" :alt="casino.nome"/>
          </a>
          <div class="d-flex flex-sm-row flex-column align-items-center mb-2">
            <a class="btn btn-sm btn-secondary btn-block text-white ml-auto m-1" rel="nofollow sponsored" target="_blank" :title="'Sito casinò' +  casino.nome" :href="casino.link_casino">Vai al sito
            </a>
            <a class="btn btn-sm btn-block text-white btn-black m-1"  :title="'Recensione casinò'  + casino.nome" :href="casino.link_recensione">Recensione
            </a>
          </div>
          </div>
        <div class="col-12 bg-gray-hight">
          <div class="dosis-font-700 text-verde font-size-big pt-2 mb-0">{{ casino.bonus_con_deposito !== 0 ? casino.bonus_con_deposito + '%' : '-'  }}</div>
          <div class="font-size-xs text-black pb-2">Bonus 1° Deposito</div>
        </div>
        <div class="col-12">
          <div class="dosis-font-700 text-verde pt-2 font-size-big mb-0">{{ casino.bonus_con_deposito_max !== 0 ? casino.bonus_con_deposito_max + ' €' : '-' }}</div>
          <div class="font-size-xs text-black pb-2">Bonus 1° Dep. Max</div>
        </div>
        <div class="col-12 bg-gray-hight">
          <div class="dosis-font-700 text-verde pt-2 font-size-big mb-0">{{ casino.bonus_senza_deposito !== 0 ? casino.bonus_senza_deposito + ' €' : '-' }}</div>
          <div class="font-size-xs text-black pb-2">Bonus Gratis</div>
        </div>
        <div class="col-12">
          <div class="dosis-font-700 text-verde pt-2 font-size-big mb-0">{{ casino.bonus_free_spins !== 0 ? casino.bonus_free_spins : '-' }}</div>
          <div class="font-size-xs text-black pb-2">Bonus Free spins</div>
        </div>
        <div class="col-12 bg-gray-hight">
          <div class="dosis-font-700 text-verde pt-2 font-size-big mb-0">{{ casino.playthrough !== 0 ? casino.playthrough + 'x' : '-' }}</div>
          <div class="font-size-xs text-black pb-2">Play Through</div>
        </div>
        
        <div class="col-12">
           <div class="font-size-xs text-black pt-2 mb-1">Software</div>
          <div class="row m-1">
            <div class="col-4 p-0 col-sm-3" v-for="(software,i) of casino.softwares" v-bind:key="software.id">
              <div v-if="i <3 || expandedSoftware">
                <img class="p-1 border m-1 img-fluid" :src="software.logo_50">
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center text-center flex-wrap mb-2">
          <button class="btn btn-sm btn-secondary" v-if="casino.softwares.length  >3" @click="toggle('Software')">{{(expandedSoftware ? '-' : '+') + (casino.softwares.length - 3) }}</button>
          </div>
         
        </div>
        
        <div class="col-12 bg-gray-hight">
        <div class="font-size-xs text-black pt-2 mb-1">Pagamenti</div>
        <div class="row m-1">
            <div class="col-4 p-0 col-sm-3" v-for="(payment,i) of casino.payments" v-bind:key="payment.id">
              <span v-if="i <3 || expandedPayment">
                <img class="p-1 border m-1 img-fluid" :src="payment.logo_50">
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center text-center flex-wrap mb-2">
          <button class="btn btn-sm btn-secondary" v-if="casino.payments.length>3" @click="toggle('Payment')">{{(expandedPayment ? '-' : '+') + (casino.payments.length - 3) }}</button>
          </div>
          
        </div>

        <div class="col-12">
        <div class="font-size-xs text-black pt-2 mb-1">Giochi</div>
          <div class="row m-1">
            <div class="col-12 p-0 col-sm-4" v-for="(game,i) of casino.games" v-bind:key="game.id">
              <div v-if="i <3 || expandedGame">
                <p class="font-size-sm dosis-font-700 text-verde p-1 border m-0">{{game.name}}</p>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center text-center flex-wrap mb-2">
            <button class="btn btn-sm btn-secondary" v-if="casino.games.length  >3" @click="toggle('Game')">{{(expandedGame ? '-' : '+') + (casino.games.length - 3) }}</button>
            </div>
          
        </div>

        <div class="col-12 bg-gray-hight">
        <div class="font-size-xs text-black border-bottom pt-2 mb-1">Giochi live</div>
          <div class="row m-1">
            <div class="col-12 p-0 col-sm-4" v-for="(game,i) of casino.games_live" v-bind:key="game.id">
              <div v-if="i <3 || expandedLiveGame">
                <p class="font-size-sm dosis-font-700 text-verde p-1 border m-0">{{game.name}}</p>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center text-center flex-wrap mb-2">
          <button class="btn btn-sm btn-secondary"  v-if="casino.games_live.length  >3 " @click="toggle('LiveGame')">{{(expandedLiveGame ? '-' : '+') + (casino.games_live.length - 3) }}</button>
          </div>
          
        </div>
        <div class="col-12 col-sm-6">
          <p class="font-size-xs text-black text-center m-1 border"> <span class="dosis-font-700 font-size-sm"><i v-if="casino.live" class="fe fe-check-circle text-verde mr-2"></i>
              <i v-else class="fe fe-x-circle mr-2"></i></span>
            Giochi live
          </p>
        </div>

        <div class="col-12 col-sm-6">
          <p class="font-size-xs text-black text-center m-1 border"> <span class="dosis-font-700 font-size-sm"><i v-if="casino.mobile_con_app" class="fe fe-check-circle text-verde mr-2"></i>
              <i v-else class="fe fe-x-circle mr-2"></i></span>
            App mobile
          </p>
        </div>
        <div class="col-12 mt-2">
        <div class="d-flex flex-sm-row flex-column align-items-center mb-2">
            <a class="btn btn-sm btn-secondary btn-block text-white ml-auto m-1" rel="nofollow sponsored" target="_blank" :title="'Sito casinò ' +  casino.nome" :href="casino.link_casino">Vai al sito
            </a>
            <a class="btn btn-sm btn-block text-white btn-black m-1"  :title="'Recensione casinò '  + casino.nome" :href="casino.link_recensione">Recensione
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store';

  export default {
    name: 'CasinoCompareItem',

    data: function() {
      return {
        expandedSoftware:false,
        expandedPayment:false,
        expandedGame:false,
        expandedLiveGame:false
      }
    },

    methods: {
      toggle(type) {

        this['expanded' + type] = !this['expanded' + type];
      },
      addToCompare() {
        store.getters.compare.push(this.casino);
        store.getters.results.find((e) => e.id == this.casino.id).compared = true;
      },
      removeToCompare() {
        store.commit(
          'setCompare',
          store.getters.compare.filter((e) => e.id !== this.casino.id)
        );
        store.getters.results.find(
          (e) => e.id == this.casino.id
        ).compared = false;
      },
    },
    props: ['casino'],
    store,
    watch: {},
  };
</script>